import React from 'react'
import PropTypes from 'prop-types'
import style from './style.scss' //NOSONAR

const TitleWithBar = (props) => {
    const { 
        additionalText,
        buttonText,
        buttonCallback,
        customClassName,
        size,
        title,
    } = props

    return (
        <div className={`title-with-bar ${size ? `title-with-bar-${size} ` : ''}${customClassName ? customClassName : ''}`}>
            <div className="title-with-bar-wrapper">
                <h2 className="title-with-bar-text">
                    {title}
                </h2>
                {additionalText && (
                    <span className="title-with-bar-aditional-text">
                        {additionalText}
                    </span>
                )}
            </div>
            {buttonText && buttonCallback && (
                <button className="new-link new-link-small title-with-bar-button" onClick={buttonCallback}>
                    {buttonText}
                </button>
            )}
        </div>
    )
}

TitleWithBar.propTypes = {
    title: PropTypes.string.isRequired,
    customClassName: PropTypes.string,
    buttonText: PropTypes.string,
    buttonCallback: PropTypes.func,
    buttonToRight: PropTypes.bool,
    size: PropTypes.string,
    additionalText: PropTypes.string,
}

export default TitleWithBar
